import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX, ShieldQuestion } from "lucide-react";
import type { LicenceCheck } from "../../lib/types";

const STYLE: Record<LicenceCheck["status"], { cls: string; label: string; Icon: typeof ShieldCheck }> = {
  valid: { cls: "bg-emerald-50 text-emerald-700 ring-emerald-200", label: "Licence valid", Icon: ShieldCheck },
  expiring: { cls: "bg-amber-50 text-amber-800 ring-amber-200", label: "Licence expiring", Icon: ShieldAlert },
  expired: { cls: "bg-rose-50 text-rose-700 ring-rose-200", label: "Licence expired", Icon: ShieldX },
  none: { cls: "bg-rose-50 text-rose-700 ring-rose-200", label: "No valid licence", Icon: ShieldQuestion },
};

export function LicenceBadge({ lic, testId }: { lic?: LicenceCheck | null; testId?: string }) {
  if (!lic) return null;
  const s = STYLE[lic.status];
  return <span title={lic.message} data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ${s.cls}`}><s.Icon className="h-3 w-3" />{s.label}</span>;
}

export function LicenceBanner({ lic }: { lic?: LicenceCheck | null }) {
  if (!lic) return null;
  const warn = lic.status === "none" || lic.status === "expired";
  const s = STYLE[lic.status];
  return (
    <div data-testid="booking-licence-banner" className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${warn ? "border-rose-200 bg-rose-50 text-rose-800" : lic.status === "expiring" ? "border-amber-200 bg-amber-50 text-amber-800" : "border-emerald-200 bg-emerald-50 text-emerald-800"}`}>
      <s.Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <p className="font-semibold">{s.label} · {lic.driver_name}</p>
        <p className="text-xs opacity-90">{lic.message}{lic.license_class ? ` · class ${lic.license_class}` : ""}{warn ? " — booking is not blocked; admins have been alerted to verify before hand-over." : ""}</p>
      </div>
    </div>
  );
}
